import { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTheme } from 'styled-components/macro';
import { LinkPropsType } from './link.types';
import { StyledWrapper } from './link.styled';

/** Описание пропсов и ньюансов -> link.d.ts */
export const Link = observer(
  forwardRef<HTMLAnchorElement | HTMLButtonElement, LinkPropsType>(
    (
      { asButton = false, variant = 'button-14', leftIcon, children, ...props },
      ref
    ) => {
      const theme = useTheme();

      return (
        <StyledWrapper
          as={asButton ? 'button' : 'a'}
          ref={ref as React.Ref<any>}
          {...props}
        >
          {leftIcon && leftIcon}

          <span
            style={{
              fontSize: theme.fonts[variant].fontSize,
              lineHeight: theme.fonts[variant].lineHeight,
              fontWeight: theme.fonts[variant].fontWeight,
            }}
          >
            {children}
          </span>
        </StyledWrapper>
      );
    }
  )
);
